import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectStrategicAxes,
  useRetrieveStrategicAxes,
} from "@planzone/view-models";
import { Modal } from "@common/modal";
import { WeightTag } from "@common/weightTag";
import { Props } from "./types";
import { ProjectStrategicAxesTable } from "./projectStrategicAxesTable";
import { StrategicAxesIcon } from "./strategicAxesIcon";
import styles from "./styles.scss";

function ProjectStrategicAxes({ project, cancel }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { strategicAxes, retrieveStrategicAxes } = useRetrieveStrategicAxes();
  const { totalWeight, projectStrategicAxes, retrieveProjectStrategicAxes } =
    useRetrieveProjectStrategicAxes(project);

  React.useEffect(() => {
    retrieveStrategicAxes(planzone);
    !!project.uuid && retrieveProjectStrategicAxes(project);
  }, []);

  return (
    <Modal
      header={t("projectStrategicAxes.title")}
      className={styles.modal}
      close={cancel}
    >
      <div className={styles.projectStrategicAxes}>
        <div className={styles.header}>
          <p className={styles.label}>{t("strategicAxesPage.table.code")}</p>
          <p className={styles.label}>
            {t("strategicAxesPage.table.strategicAxis")}
          </p>
          <p className={styles.label}>{t("strategicAxesPage.table.weight")}</p>
          <p className={classNames(styles.label, styles.operator)}>X</p>
          <p className={styles.label}>{t("projectStrategicAxes.coherence")}</p>
          <p className={classNames(styles.label, styles.operator)}>=</p>
          <p className={styles.label}>{t("projectStrategicAxes.score")}</p>
        </div>
        <div className={styles.main}>
          <ProjectStrategicAxesTable
            strategicAxes={strategicAxes}
            projectStrategicAxes={projectStrategicAxes}
            project={project}
          />
        </div>
        <div className={styles.footer}>
          <div className={styles.footerTitle}>
            <StrategicAxesIcon className={styles.icon} />
            {t("projectStrategicAxes.scoring")}
          </div>
          <WeightTag
            weight={totalWeight}
            maxWeight={strategicAxes.reduce(
              (acc, { weight }) => acc + weight * 2,
              0,
            )}
          />
        </div>
      </div>
    </Modal>
  );
}

export { ProjectStrategicAxes };
